export const filterRentals = ({
  rentalsData,
  rentalSearch,
  rentalStatusFilter,
  dateFilter,
}) => {
  return rentalsData.filter((rental) => {    const matchesSearch =
      rental.customer.firstName
        .toLowerCase()
        .includes(rentalSearch.toLowerCase()) ||
      rental.customer.lastName
        .toLowerCase()
        .includes(rentalSearch.toLowerCase()) ||
      `${rental.customer.firstName} ${rental.customer.lastName}`
        .toLowerCase()
        .includes(rentalSearch.toLowerCase()) ||
      rental.carName.toLowerCase().includes(rentalSearch.toLowerCase()) ||
      rental.pickupLocation
        .toLowerCase()
        .includes(rentalSearch.toLowerCase()) ||
      rental.returnLocation.toLowerCase().includes(rentalSearch.toLowerCase());

    const matchesStatus =
      rentalStatusFilter === "all" || rental.status === rentalStatusFilter;

    const matchesDate =
      !dateFilter.startDate ||
      !dateFilter.endDate ||
      (new Date(rental.pickupDateTime) >= dateFilter.startDate &&
        new Date(rental.returnDateTime) <= dateFilter.endDate);

    return matchesSearch && matchesStatus && matchesDate;
  });
};
